import {takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as rms from './receiptManagementSlice';
import * as uis from '../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../Auth';
import { verifyReceiptApi, verifyOTPApi, renderServiceApi, getServiceRenderReport, getOTPApi } from './receiptManagementAPI';


export function* onVerifyReceiptStartAsync({ payload }){

    try{
        
        yield put(rms.actions.startCall({ callType: rms.callTypes.findRcpt }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(verifyReceiptApi, reqBody);        
        
        if(response.status === 200){
            let receipt = response.data;
            yield put(rms.actions.receiptVerified({ receipt }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 404){
            let receipt = undefined;
            yield put(rms.actions.receiptVerified({ receipt }));
        } else if(error.response.status === 403){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error verifying the receipt number."
            }));

            yield put(rms.actions.catchError({
                callType: rms.callTypes.findRcpt,
                error: "There was an error verifying the receipt number."
            }));
        }
    }

};

export function* onRenderServiceStartAsync({ payload }){

    try{
        
        yield put(rms.actions.startCall({ callType: rms.callTypes.updateRcptStat }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.data
            }
        };

        const response = yield call(renderServiceApi, payload.provAgencyId, payload.id, reqBody);        

        if(response.status === 200){
            let updatedReceipt = response.data;
            yield put(rms.actions.renderService({ updatedReceipt }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }


            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error with updating the verified receipt status to render service."
            }));

            yield put(rms.actions.catchError({
                callType: rms.callTypes.updateRcptStat,
                error: "There was an error with updating the verified receipt status to render service."
            }));
        }
    }

};

export function* onFetchServiceRenderReportStartAsync({ payload }){

    try{
        
        yield put(rms.actions.startCall({ callType: rms.callTypes.fetchReportStr }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(getServiceRenderReport, reqBody);        

        if(response.status === 200){
            let reportStr = response.data;
            yield put(rms.actions.fetchedReport({ reportStr }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }


            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error fetching the report for the service rendered."
            }));

            yield put(rms.actions.catchError({
                callType: rms.callTypes.fetchReportStr,
                error: "There was an error fetching the report for the service rendered."
            }));
        }
    }

};

export function* onVerifyOTPStartAsync({ payload }){

    try{
        
        yield put(rms.actions.startCall({ callType: rms.callTypes.verifyOTP }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.otpQuery
            }
        };

        const response = yield call(verifyOTPApi, reqBody);        

        if(response.status === 200){
            let res = response.data;
            yield put(rms.actions.verifyOTP({ res }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }


            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error verifying the OTP code."
            }));

            yield put(rms.actions.catchError({
                callType: rms.callTypes.verifyOTP,
                error: "There was an error verifying the OTP code."
            }));
        }
    }

};

export function* onSendOTPStartAsync({ payload }){

    try{
        
        yield put(rms.actions.startCall({ callType: rms.callTypes.sendOTP }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.query
            }
        };

        const response = yield call(getOTPApi, reqBody);        

        if(response.status === 200){
            let res = response.data;
            yield put(rms.actions.otpSent({ res }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }


            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error resending the OTP code."
            }));

            yield put(rms.actions.catchError({
                callType: rms.callTypes.sendOTP,
                error: "There was an error resending the OTP code."
            }));
        }
    }

};

export function* onResetStartAsync(){

    try{
        
        yield put(rms.actions.startCall({ callType: rms.callTypes.action }));

        yield put(rms.actions.reset());       

    }
    catch(error){

        console.log(error);


        yield put(uis.actions.showNotification({
            status:"error",
            title:"Error",
            message: "Error resetting state."
        }));
    }

};

export const actionTypes = {

    VerifyReceipts: "[VerifyReceipts] Verify Receipts API Action",
    VerifyOTPCode: "[VerifyOTPCode] Verify OTP Code API Action",
    SendOTP: "[SendOTP] Send the OTP Code API Action",
    RenderService: "[RenderService] Render Service API Action",
    FetchReportStr: "[FetchReportString] Fetch Service Render Report API Action",
    Reset: "[ResetState] Reset State Action"
};

export const actions = {

    verifyReceipts: (deptId, queryParams) => ({ type: actionTypes.VerifyReceipts, payload: { deptId, queryParams } }),
    verifyOTPCode: (otpQuery) => ({ type: actionTypes.VerifyOTPCode, payload: { otpQuery }}),
    sendOTPCode: (query) => ({ type: actionTypes.SendOTP, payload: { query } }),
    renderService: (provAgencyId, id, data) => ({ type: actionTypes.RenderService, payload: { provAgencyId, id, data }}),
    fetchReportStr: (queryParams) => ({ type: actionTypes.FetchReportStr, payload: { queryParams } }),
    reset: () => ({ type: actionTypes.Reset, payload: { undefined }})

};

export function* verifyReceipts(){

    yield takeEvery(actionTypes.VerifyReceipts, onVerifyReceiptStartAsync);    
};

export function* verifyOTPCode(){

    yield takeEvery(actionTypes.VerifyOTPCode, onVerifyOTPStartAsync);
};

export function* sendOTPCode(){

    yield takeEvery(actionTypes.SendOTP, onSendOTPStartAsync);
};

export function* renderService(){

    yield takeEvery(actionTypes.RenderService, onRenderServiceStartAsync);
};

export function* fetchReportStr(){

    yield takeEvery(actionTypes.FetchReportStr, onFetchServiceRenderReportStartAsync);
};

export function* reset(){

    yield takeEvery(actionTypes.Reset, onResetStartAsync);
};

const rmsSagas = [
    fork(verifyReceipts),
    fork(verifyOTPCode),
    fork(sendOTPCode),
    fork(renderService),
    fork(fetchReportStr),
    fork(reset)
];

export function* saga(){
    yield all ([...rmsSagas]);
};
